import React from "react";
import { motion } from "framer-motion";
import Section from "./Section";
import {
  KeyRound,
  Languages,
  BedDouble,
  Wrench,
  Utensils,
  Sparkles,
  MessageSquare,
  BarChart3,
  Cable,
  Shirt,
  Star,
  Calendar,
  ClipboardList,
  LayoutDashboard,
} from "lucide-react";

const features = [
  { icon: KeyRound, title: "Digital pre check-in", desc: "Bypass the queue, arrive to a room." },
  { icon: KeyRound, title: "Digital room key", desc: "Contactless access from a phone." },
  { icon: Languages, title: "Multilingual comms", desc: "13+ languages, real-time." },
  { icon: MessageSquare, title: "Guest requests", desc: "Trackable, actionable, SLA-bound." },
  { icon: Utensils, title: "Room service", desc: "Interactive digital menus." },
  { icon: BedDouble, title: "Housekeeping", desc: "Automated recurring tasks." },
  { icon: Wrench, title: "Maintenance", desc: "Preventive & reactive workflows." },
  { icon: Calendar, title: "Restaurant booking", desc: "View menus. Reserve tables." },
  { icon: Shirt, title: "Laundry", desc: "One-tap requests." },
  { icon: Star, title: "Feedback", desc: "Digital, contextual, real-time." },
  { icon: ClipboardList, title: "Task management", desc: "Assignments · escalations." },
  { icon: LayoutDashboard, title: "Management dashboard", desc: "Real-time operations." },
  { icon: BarChart3, title: "Reports", desc: "Monthly, weekly, per-shift." },
  { icon: Sparkles, title: "Analytics", desc: "KPIs · guest satisfaction." },
  { icon: Cable, title: "Integrations", desc: "PMS · POS · IPTV · locks." },
];

export default function Features() {
  return (
    <Section id="features" overline="Features" testId="features-section">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <h2
          className="font-display text-white text-[36px] md:text-[52px] leading-[1.02] tracking-tight max-w-2xl"
          style={{ fontWeight: 800 }}
        >
          Everything a hotel runs on.{" "}
          <span className="grad-text">In one place.</span>
        </h2>
        <p className="text-white/70 text-[15px] max-w-sm">
          Fifteen production-ready capabilities, refined for real operations —
          not a demo reel.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-white/[0.08] rounded-2xl overflow-hidden border border-white/15">
        {features.map((f, i) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.02 }}
            className="group relative bg-brand-surface p-6 md:p-7 min-h-[170px] hover:bg-brand-elevated transition-colors"
            data-testid={`feature-${f.title.toLowerCase().replace(/[^a-z]/g, "-")}`}
          >
            <div className="w-10 h-10 rounded-lg bg-brand-purple/40 grid place-items-center text-white group-hover:bg-brand-orange group-hover:text-white transition-colors">
              <f.icon size={18} />
            </div>
            <div
              className="mt-5 font-display text-white text-[17px] leading-tight"
              style={{ fontWeight: 700 }}
            >
              {f.title}
            </div>
            <div className="mt-1.5 text-white/65 text-[13px]">{f.desc}</div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
